import { DashboardResponseSchema, type DashboardResponse } from "@models";
import { useQuery } from "@tanstack/react-query";
import { getDashboardQueryKey } from "../../config";
import { getDashboard } from "../../services";

export const useGetDashboard = ({
  orgId,
  deviceId,
  enabled = true,
}: {
  orgId: string;
  deviceId?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getDashboardQueryKey(orgId, deviceId),
    queryFn: async () => {
      const { data } = await getDashboard(orgId, deviceId);
      return (await DashboardResponseSchema.validate(
        data
      )) as DashboardResponse;
    },
    enabled: enabled && !!orgId,
  });
};


